import React, { useContext, useEffect, useState, useMemo } from 'react';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { Alert } from '@one-thd/sui-atomic-components';
import { QueryProvider, extend, useDataModel } from '@thd-nucleus/data-sources';
import { bool } from 'prop-types';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { BuyAgain } from '@thd-olt-component-react/buy-again';
import { CustomerAccountNavigation, NavigationDrawer, useAccountCrumbs, } from '@thd-olt-component-react/customer-account-navigation';
import { ShippingAddressCard } from '@thd-olt-component-react/shipping-address-card';
import { PaymentMethodCard } from '@thd-olt-component-react/payment-method-card';
import { PaintPurchaseHistory } from '@thd-olt-component-react/paint-purchase-history';
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ReorderRecommendations } from '@thd-olt-component-react/thd-recs-containers';
import { RecentPurchases, RecentOrders, } from '@thd-olt-component-react/recent-order-details';
import { LoyaltyWelcomeCard } from '@thd-olt-component-react/loyalty-benefits';
import { UserListsCarousel } from '@thd-olt-component-react/user-lists';
import { ProjectsRecapCard } from '@thd-olt-component-react/project-summary';
import { StorePod } from '@thd-olt-component-react/store-pod';
import { useCustomerInfo } from '../hooks/use-customer-info';
import { ProfileProvider } from '../contexts/profile-context';
import { PageTitle } from '../components/shared/page-title/page-title';
import { useInterceptors } from '../hooks/use-interceptors';
import Spinner from '../components/shared/spinner/spinner';
import { DashboardAccountDetails } from '../components/dashboard-account-details/dashboard-account-details';
import { DashboardRecentActivity } from '../components/dashboard-recent-activity/dashboard-recent-activity';
import { DashboardPlanYourJobs } from '../components/dashboard-plan-your-jobs/dashboard-plan-your-jobs';
import { DashboardHeading } from '../components/dashboard-heading/dashboard-heading';
import { DashboardMilitaryBanner } from '../components/dashboard-military-banner/dashboard-military-banner';
import { mapCrumbsToStaticCrumbs } from '../utils/breadcrumbs';
import { setDashboardPageAnalytics } from '../utils/dashboard-analytics';
var DashboardPageContent = function (_a) {
    var isB2B = _a.isB2B;
    var theme = useTheme(DashboardPageContent);
    var _b = theme.props, hideDashboardAccountDetails = _b.hideDashboardAccountDetails, hideDashboardPlanYourJobs = _b.hideDashboardPlanYourJobs, hideDashboardRecentActivity = _b.hideDashboardRecentActivity;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _c = useState(null), generalError = _c[0], setGeneralError = _c[1];
    var _d = useContext(ExperienceContext), isConsumerApp = _d.isConsumerApp, channel = _d.channel;
    var isMobile = channel === 'mobile';
    var redirectError = useInterceptors().redirectError;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _e = useState(false), isLoading = _e[0], setLoading = _e[1];
    var staticCrumbs = mapCrumbsToStaticCrumbs(useAccountCrumbs());
    var channelId = channel === 'mobile' ? 2 : 1;
    var _f = useCustomerInfo(), customerAccountId = _f.svocID, userId = _f.userID;
    var loyaltyData = useDataModel('loyaltyMembershipDetails', {
        variables: { userId: userId, customerAccountId: customerAccountId, channelId: channelId },
        ssr: false,
        skip: !userId || !customerAccountId || !isB2B,
        context: { withAuth: true },
    }).data;
    useEffect(function () {
        setDashboardPageAnalytics();
    }, []);
    var hasProjectBenefit = useMemo(function () {
        var _a, _b, _c;
        if (!loyaltyData)
            return false;
        return !!((_c = (_b = (_a = loyaltyData === null || loyaltyData === void 0 ? void 0 : loyaltyData.loyaltyMembershipDetails) === null || _a === void 0 ? void 0 : _a.proTiers) === null || _b === void 0 ? void 0 : _b.benefitTags) === null || _c === void 0 ? void 0 : _c.find(function (_a) {
            var tagName = _a.tagName;
            return tagName === 'ProjectBenefit';
        }));
    }, [loyaltyData]);
    return (React.createElement("div", { className: "grid isBound" },
        React.createElement("div", { className: "col__12-12" },
            React.createElement(Spinner, { active: isLoading }),
            redirectError ? (React.createElement("div", { className: "sui-pt-8" },
                React.createElement(Alert, { status: "info" }, redirectError.message))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sui-grid sui-gap-3 sui-py-3" },
                    !isConsumerApp && (React.createElement(ErrorBoundary, { name: "breadcrumbs" },
                        React.createElement(Breadcrumbs, { staticCrumbs: staticCrumbs }))),
                    React.createElement(PageTitle, { title: "Account Dashboard", shouldShowDrawer: true })),
                React.createElement("div", { className: "sui-grid sui-grid-cols-12 sui-gap-5 sui-py-3" },
                    React.createElement("div", { className: "sui-col-span-12 lg:sui-col-span-3" },
                        React.createElement(ErrorBoundary, { name: "customer-account-navigation-desktop" },
                            React.createElement(CustomerAccountNavigation, null))),
                    React.createElement("div", { className: "sui-col-span-12 lg:sui-col-span-9" }, generalError ? (React.createElement(Alert, { status: "error" }, generalError.message)) : (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-11" },
                        React.createElement(DashboardHeading, null),
                        React.createElement(ErrorBoundary, { name: "military-banner" },
                            React.createElement(DashboardMilitaryBanner, null)),
                        !hideDashboardRecentActivity && (React.createElement(DashboardRecentActivity, { isB2B: isB2B, isMobile: isMobile })),
                        (isB2B || !hideDashboardPlanYourJobs) && (React.createElement(DashboardPlanYourJobs, { isB2B: isB2B, hasProjectBenefit: hasProjectBenefit })),
                        !hideDashboardAccountDetails && (React.createElement(DashboardAccountDetails, { isB2B: isB2B })))))))))));
};
DashboardPageContent.displayName = 'DashboardPageContent';
DashboardPageContent.themeProps = {
    hideDashboardAccountDetails: bool,
    hideDashboardPlanYourJobs: bool,
    hideDashboardRecentActivity: bool,
};
DashboardPageContent.defaultThemeProps = {
    hideDashboardAccountDetails: false,
    hideDashboardPlanYourJobs: true,
    hideDashboardRecentActivity: false,
};
DashboardPageContent.dataModel = extend(CustomerAccountNavigation, NavigationDrawer, ReorderRecommendations, UserListsCarousel, RecentPurchases, RecentOrders, LoyaltyWelcomeCard, ShippingAddressCard, PaymentMethodCard, StorePod, Breadcrumbs, PaintPurchaseHistory, ProjectsRecapCard, DashboardMilitaryBanner, BuyAgain);
export var DashboardPage = function (_a) {
    var customerType = _a.customerType, svocId = _a.svocId, userId = _a.userId;
    var isB2B = customerType.toUpperCase() === 'B2B';
    var storeId = useStoreId();
    var defaultVars = {
        storeId: storeId,
        skipImages: true,
        skipKPF: true,
        skipSpecificationGroup: true,
        skipInstallServices: true,
        skipSubscribeAndSave: true,
        customerAccountId: svocId,
        userId: userId,
    };
    return (React.createElement(ProfileProvider, { isB2B: isB2B },
        React.createElement(QueryProvider, { defaultVariables: defaultVars, cacheKey: "dashboard-page" },
            React.createElement(DashboardPageContent, { isB2B: isB2B }))));
};
DashboardPage.displayName = 'DashboardPage';
